import * as Yup from 'yup';

export default function LeaveRequestSchema() {
  return Yup.object({
    leaveType: Yup.string()
      .oneOf(['sick_emergency', 'personal'], 'Please select a valid leave type')
      .required('Leave type is required'),

    startDate: Yup.date().nullable().required('Start date is required'),
    endDate: Yup.date()
      .nullable()
      .required('End date is required')
      .min(Yup.ref('startDate'), 'End date must be greater than or equal to start date')
      .when('isHalfDay', {
        is: true,
        then: (schema) => schema.min(Yup.ref('startDate'), 'End date must be equal to start date for half-day leave'),
        otherwise: (schema) => schema.min(Yup.ref('startDate'), 'End date must be greater than or equal to start date'),
      }),
    isHalfDay: Yup.boolean(),
    halfDayType: Yup.string().when('isHalfDay', {
      is: true,
      then: (schema) =>
        schema
          .oneOf(['first_half', 'second_half'], 'Please select half day type')
          .required('Half day type is required when selecting half day leave'),
      otherwise: (schema) => schema.notRequired(),
    }),
    reason: Yup.string().max(500, 'Reason must be less than 500 characters').required('Reason is required'),
    reviewers: Yup.array()
      .of(Yup.number().integer().positive())
      .min(1, 'At least one reviewer must be selected')
      .required('At least one reviewer is required'),
  });
}
